<template>
  <div class="indexPage">
    <job-header-simple header_title="发放记录" header_border="header_border"></job-header-simple>
    <van-sticky style="position:relative;z-index:99">
      <van-row>
        <van-col span="8" class="item_tab" @click="handleMonthClick()">
          {{month}}
          <van-icon name="arrow-up" class="icon" v-if="inMonthClicked" />
          <van-icon name="arrow-down" class="icon" v-else />
        </van-col>
        <van-col span="8" class="item_tab" @click="handleStatusClick()">
          <span class="van-ellipsis">{{statusFilter}}</span>
          <van-icon name="arrow-up" class="icon" v-if="sendMonthClicked" />
          <van-icon name="arrow-down" class="icon" v-else />
        </van-col>
        <van-col span="8" class="item_tab" @click="handleCompanyClick()">
          <span class="van-ellipsis">{{companyFilter}}</span>
          <van-icon name="arrow-up" class="icon" v-if="companyClicked" />
          <van-icon name="arrow-down" class="icon" v-else />
        </van-col>
      </van-row>
    </van-sticky>
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="init"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
      >
        <div class="public_empty_section salary" v-if="showEmpty">暂无发放记录</div>
        <div class="item" v-for="(item, index) in salaryList" :key="index">
          <header>{{item.year}}
            <span>{{item.sum}}</span>
          </header>
          <ul>
            <li v-for="detail in item.detail" :key="detail.id" class="van-hairline--bottom">
              <div class="line_1">
                <div class="left">{{detail.ecompanyName}}</div>
                <div class="right">{{detail.actuallyPaid}}</div>
              </div>
              <div class="line_2">
                <div class="left">{{detail.createDate}}</div>
                <div class="right text-success" v-if="detail.payStatus == 'paid'">已付款</div>
                <div class="right text-danger" v-if="detail.payStatus == 'reject'">被驳回</div>
                <div class="right text-warning" v-if="detail.payStatus == 'revocation'">已撤销</div>
                <div class="right text-primary" v-if="detail.payStatus == 'stay_apply'">待申请</div>
                <div class="right text-success" v-if="detail.payStatus == 'stay_pay'">待付款</div>
                <div class="right text-primary" v-if="detail.payStatus == 'applying'">申请中待审核</div>
              </div>
            </li>
          </ul>
        </div>
      </van-list>
    </div>
    <!-- 时间选择弹框 -->
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        @confirm="handleConfirm"
        @cancel="handleConcel"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <!-- 状态选择弹框 -->
    <van-popup v-model="showStatus" position="bottom">
      <van-picker
        show-toolbar
        title="选择状态"
        :columns="statusOption"
        @cancel="onStatusCancel"
        @confirm="onStatusConfirm"
      />
    </van-popup>
    <!-- 公司选择弹框 -->
    <van-popup v-model="showCompany" position="bottom">
      <van-picker
        show-toolbar
        title="选择公司"
        :columns="companyOption"
        @cancel="onCompanyCancel"
        @confirm="onCompanyConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  List,
  DatetimePicker,
  Popup,
  Sticky,
  Row,
  Col,
  Icon,
  Picker
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import moment from "moment";
export default {
  components: {
    [List.name]: List,
    [Popup.name]: Popup,
    [Sticky.name]: Sticky,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
    jobHeaderSimple
  },
  data() {
    return {
      minDate: new Date(2019, 8, 1),
      maxDate: new Date(),
      currentDate: new Date(), //时间选择器时间初始化
      show: false, //时间选择弹框是否显示
      showCompany: false, //公司选择弹框是否显示
      showStatus: false,
      header_border: true,
      showEmpty: false,
      page: {
        current: 0,
        size: 10,
        total: 1
      },
      formSearch: {},
      error: false,
      loading: false,
      finished: false,
      inMonth: new Date().getMonth(),
      company: 1,
      statusOption: [
        {
          text: "被驳回",
          value: "reject"
        },
        {
          text: "已撤销",
          value: "revocation"
        },
        {
          text: "待申请",
          value: "stay_apply"
        },
        {
          text: "申请中待审核",
          value: "applying"
        },
        {
          text: "待付款",
          value: "stay_pay"
        },
        {
          text: "已付款",
          value: "paid"
        }
      ],
      companyOption: [],
      salaryList: [],
      tempCompanyIds: "",
      inMonthClicked: false,
      sendMonthClicked: false,
      companyClicked: false,
      statusSelect: true,
      statusFilter: "已付款",//默认查询已付款
      companyFilter: "外派公司"
    };
  },
  created() {
    //初始化当月月份
    this.month = "月份"; //moment(new Date()).format("YYYY.MM");
    // this.formSearch.emolumentMonth = moment(new Date()).format("YYYY-MM-DD");
  },
  methods: {
    //发放月份选择
    handleMonthClick() {
      this.show = true;
      this.inMonthClicked = true;
    },
    //发放月份选择确认
    handleConfirm(value) {
      this.month = moment(value).format("YYYY.MM");
      this.finished = false;
      this.show = false;
      this.inMonth = value;
      this.inMonthClicked = false;
      if (typeof this.inMonth != "number") {
        this.formSearch.emolumentMonth = moment(this.inMonth).format(
          "YYYY-MM-DD"
        );
      }
      this.init(1);
    },
    //发放月份取消
    handleConcel() {
      this.inMonth = null;
      this.month = "月份";
      this.formSearch.emolumentMonth = "";
      this.inMonthClicked = false;
      this.finished = false;
      this.show = false;
      this.init(1);
    },
    handleStatusClick() {
      this.showStatus = true;
    },
    onStatusCancel() {
      this.statusFilter= "发放状态";
      this.statusSelect=false;
      this.finished = false;
      this.showStatus = false;
      this.formSearch.payStatus = "";
      this.init(1);
    },
    onStatusConfirm(value) {
      this.statusSelect=true;
      this.finished = false;
      this.showStatus = false;
      this.formSearch.payStatus = value.value;
      this.statusFilter = value.text;
      this.init(1);
    },
    handleCompanyClick() {
      this.showCompany = true;
    },
    onCompanyCancel() {
      this.companyFilter= "外派公司";
      this.finished = false;
      this.showCompany = false;
      this.formSearch.companyIds = this.tempCompanyIds;
      this.init(1);
    },
    onCompanyConfirm(value) {
      this.finished = false;
      this.showCompany = false;
      this.formSearch.companyIds = value.value;
      this.companyFilter = value.text;
      this.init(1);
    },
    init(value) {
      let param = this.formSearch;
      if (typeof value == "undefined") {
        if (this.page.current >= this.page.total) {
          setTimeout(function() {
            this.finished = true;
            this.loading = false;
          }, 50);
          return;
        }
        param.current = this.page.current + 1;
      } else {
        param.current = 1;
      }
      param.size = this.page.size;
      if (this.formSearch.companyIds) {
        this.handleGetRechargeList(param);
      } else {
        api.getCompanyByPartner().then(res => {
          if (res.data.status == "200") {
            let companyIds = "";
            for (let temp of res.data.data) {
              this.companyOption.push({
                text: temp.ecompanyName,
                value: temp.ecompanyId
              });
              companyIds = companyIds + temp.ecompanyId + ",";
            }
            if (companyIds == "") {
              companyIds = "0,";
            }
            this.formSearch.companyIds = companyIds.substring(
              0,
              companyIds.length - 1
            );
            this.tempCompanyIds = this.formSearch.companyIds;
            this.handleGetRechargeList(param);
          }
        });
      }
    },
    handleGetRechargeList(param) {
      let statusFlag = this.statusSelect;
      api.getEmolumentByPartner(param).then(res => {
        if (res.data.status == "200") {
          if (param.current == 1) {
            this.salaryList = [];
          }
          // 加载状态结束
          this.loading = false;
          this.page.current = res.data.data.current;
          this.page.total = res.data.data.pages;
          this.page.size = res.data.data.size;
          let records = res.data.data.records;
          if (res.data.data.current >= res.data.data.pages) {
            this.finished = true;
          }
          let map = new Map();
          for (let record of records) {
            //时间格式化
            let createDate =
              moment(record.createDate).format("YYYY.MM") ==
              moment(new Date()).format("YYYY.MM")
                ? "本月"
                : moment(record.createDate).format("YYYY.MM");
            // record.createDate = moment(record.createDate).format(
            //   "YYYY年MM月DD日"
            // );
            if (map.has(createDate)) {
              map.get(createDate).push(record);
            } else {
              let valueTemp = [];
              valueTemp.push(record);
              map.set(createDate, valueTemp);
            }
          }
          let index = 1;
          let that = this;
          map.forEach(function(value, key) {
            let flag = true;
            for (let temp of that.salaryList) {
              if (key == temp.year) {
                temp.detail = temp.detail.concat(value);
                flag = false;
                break;
              }
            }
            if ( flag && statusFlag ) {
              // console.log("--------------------------",key,statusFlag)
              that.salaryList.push({
                // id: index++,
                year: key,
                detail: value,
                sum: 0,
              });
              let i = that.salaryList.length-1;
              let paramm={}
              paramm.companyIds = param.companyIds;
              paramm.payStatus = param.payStatus;
              if (key == "本月") {
                  paramm.emolumentMonth = (moment(new Date()).format("YYYY-MM"));
              } else {
                  paramm.emolumentMonth = (key.replace(".", "-"));
              }
              api.getEmolumentTotalByPartner(paramm).then((res) => {
                  if (res.data.status == "200") {
                      let sum = res.data.data.actuallyPaid;
                      that.salaryList[i].sum = sum;
                  }
              });
            }else if(flag){
              // console.log("--------------------------",key,statusFlag)
              that.salaryList.push({
                 year: key,
                 detail: value,
              });
            }
          });
            // if (that.salaryList.length > 0) {
            //   for (let tempIndex of that.salaryList) {
            //     let totalBalance = 0;
            //     if (tempIndex.detail != null) {
            //         tempIndex.detail.forEach(function (obj) {
            //             if (obj.payStatus == 'paid') {
            //                 totalBalance += parseFloat(obj.actuallyPaid);
            //             }
            //         });
            //     }
            //     totalBalance = totalBalance.toFixed(2);
            //     tempIndex.sum = totalBalance;
            //   }
            // }
          this.showEmpty = that.salaryList.length == 0;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.item_tab {
  font-size: 15px;
  text-align: center;
  line-height: 50px;
  background: #fff;
  .van-ellipsis {
    display: inline-block;
    max-width: 5em;
    vertical-align: middle;
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
  }
}
.list {
  padding: 0 12px;

  .item {
    header {
      font-size: 14px;
      line-height: 38px;
      padding: 0 10px;
      font-weight: 600;
      span {
        float: right;
      }
    }

    ul {
      background: #fff;
      border-radius: 6px;
      li {
        padding: 6px 20px;
        line-height: 34px;
        .left {
          float: left;
        }

        .right {
          float: right;
        }
        .line_1 {
          font-size: 14px;
          font-weight: 600;
          overflow: hidden;
        }
        .line_2 {
          font-size: 12px;
          color: #999;
          overflow: hidden;
          .right {
            display: block;
            max-width: 180px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 600;
            &.text-success {
              color: #67c23a;
            }

            &.text-danger {
              color: #f56c6c;
            }

            &.text-warning {
              color: #e6a23c;
            }

            &.text-primary {
              color: #6c7ef3;
            }
          }
        }
      }
    }
  }
}
</style>